module.exports = __webpack_public_path__ + "media/images/btn_pay_later-e1547060e24659d5a43bff10005bedbd.gif";